import { IProject } from "./projectCard.types";
import { PROJECT_TOOLTIPS, ProjectStatus } from "./projectConstants";

export const formatExportFilename = (
  projectName: string | undefined,
  type: string,
  extension: string,
): string => {
  const name: string = (projectName || "Export")
    .replace(/\s+/g, "_")
    .replace(/,/g, "");
  const date: string = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  return `${name}_${type}_${date}.${extension}`;
};

export const getProjectScoringState = (project: IProject) => {
  const isScored = project.status === ProjectStatus.Scored;
  const isScoring = project.status === ProjectStatus.InProgress;
  const hasScoringError = project.status === ProjectStatus.Error;
  const hasAttachments = project.attachments && project.attachments.length > 0;
  const hasContentColumn = project.attachments?.some(
    (att) => att.contentColumn,
  );
  // Allow scoring if not currently in progress (includes re-scoring for scored and error states)
  const canScore = hasAttachments && hasContentColumn && !isScoring;
  const canRetryScore =
    (hasScoringError || isScored) && hasAttachments && hasContentColumn;

  return {
    isScored,
    isScoring,
    hasScoringError,
    hasAttachments,
    hasContentColumn,
    canScore,
    canRetryScore,
  };
};

export const getScoreTooltip = (project: IProject): string => {
  const {
    isScoring,
    isScored,
    hasScoringError,
    hasAttachments,
    hasContentColumn,
  } = getProjectScoringState(project);

  const conditions = [
    { check: isScoring, message: PROJECT_TOOLTIPS.SCORE.IN_PROGRESS },
    {
      check: hasScoringError,
      message: PROJECT_TOOLTIPS.SCORE.RE_SCORE,
    },
    { check: !hasAttachments, message: PROJECT_TOOLTIPS.SCORE.NO_ATTACHMENTS },
    {
      check: !hasContentColumn,
      message: PROJECT_TOOLTIPS.SCORE.NO_CONTENT_COLUMN,
    },
    { check: isScored, message: PROJECT_TOOLTIPS.SCORE.RE_SCORE },
  ];

  return (
    conditions.find(({ check }) => check)?.message ||
    PROJECT_TOOLTIPS.SCORE.READY
  );
};

export const getScoreButtonLabel = (project: IProject): string => {
  const { isScored, hasScoringError } = getProjectScoringState(project);
  return isScored || hasScoringError ? "Re-Score" : "Score";
};
